/* eslint-disable camelcase */

export enum TemplateSlugs {
    zambia = 'lotto-zambia',
    nigeria = 'lotto-nigeria',
    peru = 'lotto-peru',
    haiti = 'lotto-haiti',
    korsou = 'lotokorsou',
    ggworld = 'gg-world',
    malawi = 'lotto-malawi',
    congo = 'lotto-congo',
    cameroon = 'lotto-cameroon',
    chad = 'lotto-chad',
    rd_congo = 'lotto-rd-congo',
    guinea = 'lotto-guinea',
    mozambique = 'lotto-mozambique',
    sierra_leone = 'lotto-sierra-leone',
    bahrain = 'lotto-bahrain',
    kenya = 'lotto-kenya',
    lotocash = 'lotocash',
    premier_zambia = 'premier-zambia',
    premier_peru = 'premier-peru',
    rc_lotto = 'rc-lotto',
    guatemala = 'lotto-guatemala',
    '25lotto' = '25lotto',
    '25lotto-kenya' = '25lotto-kenya',
    premier_mali = 'premier-mali',
    premier_dubai = 'premier-dubai',
    lottopark = 'lottopark',
    lotto_almabet = 'lotto-almabet',
    lttry = 'lttry',
    lottoplay_co_uk = 'lottoplay-co-uk',
    lottoplay_co_mx = 'lottoplay-co-mx',
    lottoplay_mga = 'lottoplay-mga',
    mml = 'mml',
    arabia = 'lotto-arabia',
    brasil = 'lotto-brasil',
    widget_default = 'widget',
    playport = 'playport',
    america = 'lotto-america',
    games_millions = 'gamesmillions',
    big5lottery = 'big5lottery',
    dragonlotto24 = 'dragonlotto24',
    playlottoglobal = 'playlottoglobal',
    surewinbd = 'surewinbd',
    thankyoulotto = 'thankyoulotto',
    betarena888 = 'betarena888',
    playaezra = 'playaezra',
    lottoonline = 'lottoonline',
    dotycasino = 'dotycasino',
    loteriio = 'loteriio',
    default = 'default',
    timeinn = 'timeinn',
    usloto = 'usloto',
    elitebet = 'elitebet',
    lets777 = 'lets777',
    xtodos = 'xtodos',
    lotoking = 'loto-king',
    xmolotto = 'xmolotto',
    xoxo = 'xoxo',
    hamroplay = 'hamroplay',
}
